<template>
  <div class="level is-mobile">
    <div class="level-left">
      <p class="level-item">
        <span class="connection-indicator"></span> LIVE
      </p>
    </div>
  
    <div class="level-right">
      <p class="level-item" v-if="!summoner.in_update_queue">
        Looked for new games {{ lastUpdateAttempt }}
      </p>
      <p class="level-item" v-if="summoner.in_update_queue">
        In update queue, this can take a few minutes
      </p>
      <p class="level-item">
        <button @click="checkForGames" :class="{ 'is-loading': updating || summoner.in_update_queue, 'is-danger': error }"  :disabled="justUpdated" class="button is-primary is-small">
          <span v-if="!error">CHECK NOW</span>
          <span v-if="error">{{ errorMessage }}</span>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as api from '@/api'

export default {
  props: {
    summoner: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    updating: false,
    now: Date.now(),
    error: false,
    errorMessage: '',
  }),

  computed: {
    region () {
      return this.$route.params.region
    },

    summonerName () {
      return this.$route.params.name
    },

    lastUpdateAttempt () {
      if (!this.summoner.league_update_attempted_at) {
        return 'never'
      }

      return moment(this.summoner.league_update_attempted_at).from(this.now)
    },

    justUpdated () {
      if (!this.summoner.league_update_attempted_at) {
        return false
      }

      let fiveMinutesAgo = moment(this.now).subtract(5, 'minutes')

      return moment(this.summoner.league_update_attempted_at).isAfter(fiveMinutesAgo)
    },
  },

  mounted () {
    setInterval(this.updateCurrentTime, 1000)
  },

  destroyed () {
    clearInterval(this.updateCurrentTime)
  },

  methods: {
    updateCurrentTime () {
      this.now = Date.now()
    },

    checkForGames () {
      this.updating = true
      this.error = false

      api.forceLeagueUpdate(this.summonerName, this.region).then(() => {
        this.updating = false
      }).catch(({ response }) => {
        this.error = true
        this.updating = false

        if (response.status === 422) {
          let timeToWaitInMinutes = moment(response.data.data.league_update_attempted_at).add(5, 'minutes').diff(moment(), 'minutes')

          this.errorMessage = `Just updated recently, wait ${timeToWaitInMinutes} minutes`
        } else {
          this.errorMessage = 'Whoops an error occured, try again'
        }
      })
    },
  },
}
</script>

<style lang="sass" scoped>
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.level
  margin-bottom: .5rem
  font-size: .7rem

.connection-indicator
  display: inline-block
  width: 7px
  height: 7px
  background-color: #FC5384
  margin-right: 5px
  border-radius: 50%

.button.is-small
  font-size: 0.55rem
</style>



// WEBPACK FOOTER //
// ForceLeagueUpdate.vue?26801c34